import { render } from "./privacyNotice.vue?vue&type=template&id=4e598c58&scoped=true"
import script from "./privacyNotice.vue?vue&type=script&lang=js"
export * from "./privacyNotice.vue?vue&type=script&lang=js"

import "./privacyNotice.vue?vue&type=style&index=0&id=4e598c58&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e598c58"]])

export default __exports__